<template>
  <div class="hero-shape" :class="{'is-open': isOpen}" :style="computedStyle">
    <div class="hero-shape__left"></div>
    <div class="hero-shape__background"></div>
    <div class="hero-shape__right"></div>
    <div class="hero-shape__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>

  export default {
    name: "HeroShape",
    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },
      heroMdWidth: {
        type: String,
        default: "50%"
      },
      heroLgWidth: {
        type: String,
        default: "50%"
      },
      heroXlWidth: {
        type: String,
        default: "50%"
      }
    },
    computed: {
      computedStyle() {
        return {
          '--hero-md-width': this.heroMdWidth,
          '--hero-lg-width': this.heroLgWidth,
          '--hero-xl-width': this.heroXlWidth,
        }
      }
    }
  }
</script>